import * as React from 'react';
import { IFieldNumberProps } from './IFieldNumber';
import './FieldNumber.scss';
import { Field, FieldProps } from 'formik';
import { debounce, isNumber, isString } from 'lodash';
import IconButton from '@mui/material/IconButton';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const FieldNumber = (props: IFieldNumberProps) => {

    const scrollStep: number = isString(props.step) ? (Number(props.step) ?? 1) : props.step ?? 1;

    const [isFocused, setIsFocused] = React.useState<boolean>(false);
    const [guid, setGuid] = React.useState<string>('');

    const fixedDecimalsValue = (value: string) => {
        if (Number.isNaN(value)) { return "0.00"; }
        return Number(value).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 10 }).replaceAll(",", "");
    }

    if (!guid || guid == "") {
        setGuid("10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
            (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)));
    }

    const onFocus = () => {
        setIsFocused(true);
    }

    const onBlur = (e: React.FocusEvent<HTMLInputElement, Element>, onBlur: { (e: React.FocusEvent<any, Element>): void; <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void; }) => {
        setIsFocused(false);
        onBlur(e);
    }

    const onNumberChange = (e: React.ChangeEvent<HTMLInputElement>, onChange: {
        (e: React.ChangeEvent<any>): void;
        <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any> ? void : (e: string | React.ChangeEvent<any>) => void;
    }) => {
        e.target.value = e.target.value.replace(",", ".");
        onChange(e);
    }


    return (
        <Field type='number' {...props} >
            {({ field, form, meta }: FieldProps) => {
                React.useEffect(() => {
                    if (!guid || guid == "") { return; }
                    document.getElementById("number-field-spinner-" + field.name + "-" + guid)?.addEventListener("wheel", (e: WheelEvent) => {
                        e.preventDefault();
                        form.setFieldTouched(field.name, true);
                        form.setFieldValue(field.name, (Number((document.getElementById("number-field-input-" + field.name + "-" + guid) as HTMLInputElement)?.value ?? 0) + (e.deltaY > 0 ? -scrollStep : scrollStep)).toFixed(2));
                        form.validateField(field.name);
                    });
                }, [guid]);

                return (
                    <div className="number-field-container">
                        <input type="string" {...props} {...field} id={"number-field-input-" + field.name + "-" + guid}
                            value={isFocused ? field.value : fixedDecimalsValue(field.value)}
                            onChange={(e) => { onNumberChange(e, field.onChange) }} onFocus={onFocus}
                            onBlur={(e) => onBlur(e, field.onBlur)} lang="en" />
                        {!props.disabled && !props.readOnly &&
                            (<div className="number-field-spinner" id={"number-field-spinner-" + field.name + "-" + guid}
                            >
                                <IconButton className="number-field-spinner-btn"
                                    onClick={() => {
                                        form.setFieldValue(field.name, (Number(field.value) + scrollStep).toFixed(2));
                                        form.setFieldTouched(field.name, true);
                                        form.validateField(field.name);
                                    }}
                                    aria-label="step-up" size="small">
                                    <ArrowDropUpIcon fontSize="inherit" /></IconButton >
                                <IconButton className="number-field-spinner-btn"
                                    onClick={() => {
                                        form.setFieldValue(field.name, (Number(field.value) - scrollStep).toFixed(2));
                                        form.setFieldTouched(field.name, true);
                                        form.validateField(field.name);
                                    }}
                                    aria-label="step-down" size="small">
                                    <ArrowDropDownIcon fontSize="inherit" /></IconButton >
                            </div>)}
                    </div>
                )
            }
            }
        </Field>
    );
};

export default FieldNumber;
